import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Radio, { RadioProps } from '@material-ui/core/Radio';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { TableBaseStyle } from './AlmKindRegistStyle';

type Props = {
  onClickSaveButton: () => void;
  onClickCancelButton: () => void;
  buttonEnable: boolean;
};

const AlmKindRegistFooter: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = TableBaseStyle();

  return (
    <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ width: 'calc(100vw - 12px)' }}>
      <Grid item xs={2}>
        <Button
          className={classes.buttonStyle}
          variant="contained"
          color="primary"
          disabled={!props.buttonEnable}
          disableElevation
          onClick={(e) => {
            props.onClickSaveButton()
          }}
        >
          {t('AlmKindRegistFooter.保存', '保存')}
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Button
          className={classes.buttonStyle}
          variant="contained"
          color="primary"
          disabled={!props.buttonEnable}
          disableElevation
          onClick={(e) => props.onClickCancelButton()}
        >
          {t('AlmKindRegistFooter.中止', '中止')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default AlmKindRegistFooter;
